import { useSelector } from 'react-redux'
import { Element } from '../../../../common/html/element'
import {
  EMPTY_VALUE,
  ZERO_IN_FINANCIAL_STATEMENT,
} from '../../../../utils/common'
import { valToPercent } from './../../../../helpers/value'

export const PercentChange = ({ data }) => {
  const locale = useSelector((state) => state.i18n.locale)

  return (
    <Element
      style={{
        color: !data ? '#3a414b' : data > 0 ? '#3DA967' : '#E0505B',
      }}
    >
      {!(typeof data === 'number')
        ? EMPTY_VALUE
        : !data
        ? ZERO_IN_FINANCIAL_STATEMENT
        : (data > 0 ? '+ ' : '- ') + valToPercent(Math.abs(data), locale)}
    </Element>
  )
}
